import React, { ReactNode, useEffect, useState } from 'react';
import 'animate.css';
import Routes from './routes';
import TailwindToaster from './components/TailwindToaster';
import Modal from './components/Modal';
import { useRadio } from './hooks/useRadio';
import { IGlobalModalData } from './hooks/useModal';



function App() {

  const radio = useRadio();
  const [globalModalData, setGlobalModalData] = useState<IGlobalModalData>({ show: false, onClose: () => { }, component: <div></div> });

  useEffect(()=>{
    radio.subscribe('global', (data:any)=>{
      setGlobalModalData(prevState=>{
        return { ...data, component: !!data?.component ? data?.component : prevState?.component }
      })
    })
  },[])

  return (
    <div>
      <Routes />
      <TailwindToaster />
      <Modal visible={globalModalData?.show} onClose={() => globalModalData?.onClose()}>
        <div>
          {globalModalData?.component}
        </div>
      </Modal>
    </div>
  );
}

export default App;
